$w.onReady(async function () {

    let isUserMember = await getUserClient()
    console.log({ isUserMember }, "here")
    if (isUserMember.errorCode == 0) {
        //member
        $w('#button70').label = 'Сделайте свой сайт доступным >';
        $w('#button69').label = 'Перейти в Мастер специальных возможностей'
        $w('#button636').label = 'Make Your Website Accessible'
        $w('#button64').label = 'Перейти в Мастер специальных возможностей'
    }

});

export function getUserClient() {

    return fetch('https://www.wix.com/_api/wix-html-login-webapp/user/getUserDetails', {
        method: 'GET',
        credentials: 'include', //passes cookie
        cache: 'no-store', //disables cache
    }).then((result) => {
        if (result.ok) {
            console.log({ result })
            return result.json()
        }
    }).catch((err) => {
        return { err }
    })

}